// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__W8XFf","col":"CardReaderDesc_col__3z1OM","label":"CardReaderDesc_label__nGB3Z"};